import { Button } from '@eventbrite/marmalade';
import { useIntl } from 'react-intl';
import React from 'react';
import { insertLinkIntoMessage } from '../../util';
import styles from './ReportEventIntro.module.scss';

export const ReportEventIntro = (props: { onClick: () => void }) => {
    const { onClick } = props;
    const intl = useIntl();
    const startReportMessage = intl.formatMessage({
        id: 'Start Report',
        defaultMessage: 'Start Report',
    });
    const communityGuidelinesText = intl.formatMessage({
        id: 'Community Guidelines',
        defaultMessage: 'Community Guidelines',
    });
    const communityGuidelinesLink = (
        <a
            href="https://www.eventbrite.com/support/articles/en_US/Troubleshooting/community-guidelines"
            rel="noopener noreferrer"
            target="_blank"
            title={communityGuidelinesText}
        >
            {communityGuidelinesText}
        </a>
    );
    const communityGuidelinesMessage = intl.formatMessage(
        {
            id: 'Our {communityGuidelinesLink} describe the sort of content we prohibit on Eventbrite. If you suspect an event may be in violation, you can report it to us so we can investigate.',
            defaultMessage: 'Our {communityGuidelinesLink} describe the sort of content we prohibit on Eventbrite. If you suspect an event may be in violation, you can report it to us so we can investigate.',
            description: 'context: Our "Community Guidelines" describe the sort of content we prohibit on Eventbrite.',
        },
        {
            communityGuidelinesLink: communityGuidelinesText,
        }
    );
    const contactOrganizerText = intl.formatMessage({
        id: 'contact the organizer',
        defaultMessage: 'contact the organizer',
        description: 'context: we encourage you to first "contact the organizer" directly.'
    });
    const contactOrganizerLink = (
        <a
            href="https://www.eventbrite.com/support/articles/en_US/How_To/how-to-contact-the-event-organizer"
            rel="noopener noreferrer"
            target="_blank"
            title={contactOrganizerText}
        >
            {contactOrganizerText}
        </a>
    );
    const contactOrganizerMessage = intl.formatMessage(
        {
            id: 'If you have a question about an event, need to resolve a dispute, or would like to request a refund, we encourage you to first {contactOrganizerLink} directly.',
            defaultMessage: 'If you have a question about an event, need to resolve a dispute, or would like to request a refund, we encourage you to first {contactOrganizerLink} directly.',
        },
        {
            contactOrganizerLink: contactOrganizerText,
        }
    );
    const dangerMessage = intl.formatMessage({
        id: 'If you or someone else is in imminent danger as a result of an event listing, please contact your local law enforcement agency for assistance.',
        defaultMessage: 'If you or someone else is in imminent danger as a result of an event listing, please contact your local law enforcement agency for assistance.',
    });
    return (
        <div className={styles.introContainer}>
            <p>
                {insertLinkIntoMessage(
                    communityGuidelinesMessage,
                    communityGuidelinesText,
                    communityGuidelinesLink
                )}
            </p>
            <ul className={styles.introList}>
                <li className={styles.introListItem}>
                    {insertLinkIntoMessage(
                        contactOrganizerMessage,
                        contactOrganizerText,
                        contactOrganizerLink
                    )}
                </li>
                <li>{dangerMessage}</li>
            </ul>
            <Button
                onClick={onClick}
                variant='primary'
                className={styles.introButton}
            >
                {startReportMessage}
            </Button>
        </div>
    );
};
